import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {fetchAdvancedTypes} from "../../../../_apis/api";
import moment from "moment";
import {setSaveEditFixedAssetMovement} from "../../../../_reducers/activitySlice";
import {setEditFixedAssetMovement} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import DateBox from "../../../primer/DateBox";
import Input from "../../../common/Input";
import EditableTable from "../../../primer/Editable-Table";
import TextArea from "../../../common/TextArea";
import LogTable from "../../../primer/LogTable";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import {AccountingView} from "../../../primer/AccountingView/AccountingView";

const EditFixedAssetMovement = () => {
    const dispatch = useDispatch();
    const editFixedAssetMovement = useSelector((state) => state.FIXED_ASSETS.editFixedAssetMovement);
    const saveEditFixedAssetMovement = useSelector((state) => state.ACTIVITY.saveEditFixedAssetMovement);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const installationOptions = useInstallationOptions();
    const [fixedAssetsList, setFixedAssetsList] = useState([]);

    const documentTypesOptions = advancedTypes.length > 0 ?
        advancedTypes.filter((el) => el.section === "Fixed Asset Movements").map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        })
        : [];

    const preNumberGreekOptions = (advancedTypes.length > 0 && editFixedAssetMovement.installation && editFixedAssetMovement.documentType) ?
        advancedTypes.find((el) => el._id === editFixedAssetMovement.documentType)?.documentNumbering?.map((docNum) => {
            if (docNum.installationMasterId === editFixedAssetMovement.installation) {
                return {
                    value: docNum.preNumber,
                    label: docNum.preNumber === "noprefix" ? "Κενή" : docNum.preNumber,
                    number: docNum.number,
                }
            }
            return null;
        }).filter(Boolean)
        : [];

    const [incrKey, setIncrKey] = useState(0);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editFixedAssetMovement.fixedAssets, fixedAssetsList])

    const loadFixedAssetsListData = (keyword, setData) => {
        const reqData = {
            company: company.id,
            installation: editFixedAssetMovement.installation,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/list-fixed-assets`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData,
        }).then((res) => {
            if (res.data.status === "200") {
                setData(res.data.data);
            }
        }).catch((err) => {
            setData([]);
            console.log(err);
        })
    }

    const tableColumns  = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "5%",
        },
        {
            name: "Κωδικός Συστήματος / Χειροκίνητος Κωδικός",
            field: "mixedCode",
            editable: false,
            width: "30%",
        },
        {
            name: "Όνομα Παγίου",
            field: "name",
            editable: true,
            width: "50%",
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadFixedAssetsListData(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Όνομα", name: "name"},
                        {label: "Κόστος Κτήσης", name: "acquisitionCost"},
                        {label: "Αποσβεσμένο Ποσό", name: "accumulatedDepreciation"},
                    ],
                    data: fixedAssetsList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε πάγιο"
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Αποσβεσμένο Ποσό",
            field: 'amount',
            editable: true,
            width: "15%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                    maxLength: 10,
                    allowNegative: true,
                }
            }
        },
    ];

    useEffect(() => {
        dispatch(fetchAdvancedTypes({company: company.id}));
    }, [])

    useEffect(() => {
        loadFixedAssetsListData(null, setFixedAssetsList);
    }, [editFixedAssetMovement.installation])

    const handleOnChange = (e, type, name) => {
        if (!saveEditFixedAssetMovement) dispatch(setSaveEditFixedAssetMovement(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        }

        if (name === "documentType") {
            prepChange["documentTypeName"] = e.label;
            const advDoc = advancedTypes.find((el) => el._id === e.value);
            if (advDoc) {
                const preSelectedDocNumbering = advDoc?.documentNumbering?.find((el) => el.selected === "true");
                if (preSelectedDocNumbering) {
                    prepChange["preNumber"] = preSelectedDocNumbering.preNumber;
                    prepChange["number"] = +(preSelectedDocNumbering?.number || 0) + 1;
                }
            }
        } else if (name === "preNumber") {
            prepChange["number"] = +(preNumberGreekOptions.find((el) => el.value === e.value)?.number || 0) + 1;
        }
        dispatch(setEditFixedAssetMovement({...editFixedAssetMovement, ...prepChange}));
    }

    const getSumOfDataValues = (data, field = 'sum') => {
        let sum = 0;
        if (data && data.length > 0) {
            data.forEach(item => {
                sum += +item[field] || 0;
            })
        }
        return +Number(sum).toFixed(2);
    }

    const tableFunctions = {
        insert: (e, data) => {
            if (e.key === "Enter") return;
            if (!saveEditFixedAssetMovement) dispatch(setSaveEditFixedAssetMovement(true));

            if (data.field === "name") {
                const cloneFixedAssets = structuredClone(editFixedAssetMovement.fixedAssets);
                cloneFixedAssets.push({
                    _id: e.row._id,
                    no: String(cloneFixedAssets.length + 1),
                    name: e.row.name,
                    mixedCode: e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : ""),
                    amount: 0,
                });
                dispatch(setEditFixedAssetMovement({
                    ...editFixedAssetMovement,
                    fixedAssets: cloneFixedAssets,
                    sum: getSumOfDataValues(cloneFixedAssets, "amount"),
                }));
            }
        },
        update: (data, id, rowIndex, e) => {
            if (e.key === "Enter") return;
            if (!saveEditFixedAssetMovement) dispatch(setSaveEditFixedAssetMovement(true));

            const cloneFixedAssets = structuredClone(editFixedAssetMovement.fixedAssets);
            const findMatching = cloneFixedAssets[rowIndex];
            if (e?.row) { // Its advanced combo box
                findMatching._id = e.row._id;
                findMatching.name = e.row.name;
                findMatching.mixedCode = e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : "");
                findMatching.amount = 0;
            } else {
                if (!isEmpty(data.amount)) {
                    findMatching.amount = +Number(data.amount).toFixed(2);
                }
            }
            dispatch(setEditFixedAssetMovement({
                ...editFixedAssetMovement,
                fixedAssets: cloneFixedAssets,
                sum: getSumOfDataValues(cloneFixedAssets, "amount"),
            }));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditFixedAssetMovement) dispatch(setSaveEditFixedAssetMovement(true));

            const cloneFixedAssets = structuredClone(editFixedAssetMovement.fixedAssets);
            cloneFixedAssets.splice(rowIndex, 1);
            cloneFixedAssets.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setEditFixedAssetMovement({
                ...editFixedAssetMovement,
                fixedAssets: cloneFixedAssets,
                sum: getSumOfDataValues(cloneFixedAssets, "amount"),
            }));
        }
    }

    const disabledFields = isEmpty(editFixedAssetMovement.documentType);

    return (
        <React.Fragment>
            <AccountingView document={editFixedAssetMovement} />
            <div className="product-form position-relative">
                {disabledFields && <div className="overlay_w">Παρακαλώ επιλέξτε τύπο παραστατικού</div>}
                <Row>
                    <Col md={3} className="showWithOverlay">
                        <Dropdown
                            name={"documentType"}
                            label={"Τύπος Παραστατικού"}
                            key={editFixedAssetMovement.documentType}
                            defaultValue={documentTypesOptions.find((el) => el.value === editFixedAssetMovement.documentType)}
                            required={true}
                            options={documentTypesOptions}
                            onChange={(e) => handleOnChange(e, "dd", "documentType")}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"installation"}
                            label={"Εγκατάσταση"}
                            key={editFixedAssetMovement.installation}
                            defaultValue={installationOptions.find((el) => el.value === editFixedAssetMovement.installation)}
                            required={true}
                            options={installationOptions}
                            onChange={(e) => handleOnChange(e, "dd", "installation")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            label={"Ημερομηνία"}
                            name="date"
                            required={true}
                            selected={moment(editFixedAssetMovement.date).isValid() ? moment(editFixedAssetMovement.date).toDate() : null}
                            onChange={(e) => handleOnChange(e, "datebox", "date")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            label={"Σειρά"}
                            name="preNumber"
                            key={editFixedAssetMovement.preNumber}
                            defaultValue={preNumberGreekOptions.find((el) => el.value === editFixedAssetMovement.preNumber)}
                            options={preNumberGreekOptions}
                            required={true}
                            onChange={(e) => handleOnChange(e, "dd", "preNumber")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            label={"Αρίθμηση"}
                            charLimit={10}
                            name="number"
                            value={editFixedAssetMovement.number}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <Input
                            name={"reason"}
                            label={"Αιτιολογία"}
                            value={editFixedAssetMovement.reason}
                            onChange={(e) => handleOnChange(e, "input", "reason")}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <div className={"text-muted"}><i>Πίνακας παγίων</i></div>
                        <EditableTable
                            tableName={"New Fixed Asset Movement Assets"}
                            key={"New Fixed Asset Movement Assets" + incrKey}
                            allowActions={true}
                            onUpdate={tableFunctions}
                            allowInsertRow={true}
                            columns={tableColumns}
                            enableNewRowCheckbox={true}
                            data={editFixedAssetMovement.fixedAssets}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <TextArea
                            rows={"4"}
                            label={"Σημειώσεις"}
                            name={"notes"}
                            limit={"1000"}
                            value={editFixedAssetMovement.notes}
                            onChange={(e) => handleOnChange(e, "input", "notes")}
                        />
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export const EditFixedAssetMovementLog = () => {
    const editFixedAssetMovement = useSelector((state) => state.FIXED_ASSETS.editFixedAssetMovement);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>Ιστορικό κίνησης παγίων</i></div>
            <LogTable itemId={editFixedAssetMovement._id}/>
        </React.Fragment>
    )
}

export default EditFixedAssetMovement;
